<template>
  <div
    :class="[
      $style.overlay,
      { [$style.capustaOverlay]: isInternalOrigin },
    ]"
  >
    <div :class="$style.container">

      <div :class="$style.header">
        <h1 :class="$style.title">
          {{ $t('service.unavailable.title') }}
        </h1>
      </div>

      <div :class="$style.content">
        <base-card-template>
          <p v-html="$t('service.unavailable.message')"></p>
          <simple-button variant="secondary" @click="handleRedirect">
            {{ $t('try.again') }}
          </simple-button>
        </base-card-template>
      </div>

      <div :class="$style.footer">
        <div :class="$style.logo">
          <img :src="getLogoLink" alt="" />
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import SimpleButton from 'molecules/common/SimpleButton';
import BaseCardTemplate from 'templates/BaseCardTemplate';

export default {
  name: 'ServiceError',
  components: {
    SimpleButton,
    BaseCardTemplate,
  },
  computed: {
    ...mapGetters([
      'isInternalOrigin',
      'getLogoLink',
      'getRouteWithParamsByTransaction',
    ]),
  },
  methods: {
    handleRedirect() {
      this.$router.push(this.getRouteWithParamsByTransaction);
    },
  },
};
</script>

<style lang="sass" module>
  .overlay
    background-repeat: no-repeat
    background-attachment: fixed
    background-position: center
    background-size: cover

  .capustaOverlay
    background-image: url('@/assets/images/overlay/service-error-small.jpg')

    +respond-to('medium')
      background-image: url('@/assets/images/overlay/service-error-medium.jpg')

    +respond-to('large')
      background-image: url('@/assets/images/overlay/service-error-large.jpg')

  .container
    width: 100%
    max-width: 340px
    min-height: 100vh
    margin: 0 auto
    padding: 40px 15px
    display: flex
    flex-direction: column
    justify-content: space-between

    +respond-to('large')
      padding: 90px 0

  .header
    margin-bottom: 46px

  .title
    +base-title
    text-align: center

  .content
    margin-bottom: 80px

  .footer
    +flexbox
    +justify-content(center)

  .logo
    +size(96px, 66px)

    img
      width: 100%
</style>
